import { render, staticRenderFns } from "./VmDistrictSelect.vue?vue&type=template&id=6edc19e0&scoped=true"
import script from "./VmDistrictSelect.vue?vue&type=script&lang=js"
export * from "./VmDistrictSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc19e0",
  null
  
)

export default component.exports